// extracted by mini-css-extract-plugin
module.exports = {"modal":"InfoModal_modal__2nqah","modal_text":"InfoModal_modal_text__3KPAa"};